import TextField from '@material-ui/core/TextField';
import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  name: string;
  type?: string;
  min?: string | number;
  max?: string | number;
  step?: string | number;
  label?: string;
  placeholder?: string;
  error?: string;
  size?: 'small' | 'large';
  fullWidth?: boolean;
  className?: string;
  defaultValue?: string | number;
  required?: boolean;
  [any: string]: any;
}

export const MuiInput = React.forwardRef((props: IProps, ref: any) => {
  const {
    name,
    label,
    type = 'text',
    min,
    max,
    step = 'any',
    error,
    size = 'large',
    fullWidth = true,
    className,
    defaultValue,
    required,
    value,
    variant = 'outlined',
    ...rest
  } = props;
  const { t } = useTranslation('admin');
  const id = `input-${name}`;
  const rootClasses = cn('marapp-qa-input', {
    [className]: !!className,
  });
  return (
    <>
      <TextField
        className={rootClasses}
        defaultValue={value || defaultValue}
        error={!!error}
        fullWidth={fullWidth}
        helperText={error && t(error)}
        id={id}
        name={name}
        label={t(label)}
        required={!!required}
        type={type}
        variant={variant}
        FormHelperTextProps={{
          className: `marapp-qa-error marapp-qa-error-${id}`,
        }}
        inputProps={{ ...(type === 'number' && { min, max, step }) }}
        {...rest}
      />
    </>
  );
});
